export const mspTicketsSortColumns = {
  id: 'id',
  statusName: 'status/name',
  summary: 'summary',
  priorityName: 'priority/name',
  dateEntered: 'dateEntered',
  lastUpdated: '_info/lastUpdated',
  closedDate: 'closedDate',
  contactFullName: 'contact/name',
  boardName: 'board/name',
  siteName: 'site/name',
};
